import { render, staticRenderFns } from "./ConfirmMarkPapasAsApproved.vue?vue&type=template&id=9662f0b0&scoped=true"
import script from "./ConfirmMarkPapasAsApproved.vue?vue&type=script&lang=js"
export * from "./ConfirmMarkPapasAsApproved.vue?vue&type=script&lang=js"
import style0 from "./ConfirmMarkPapasAsApproved.vue?vue&type=style&index=0&id=9662f0b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9662f0b0",
  null
  
)

export default component.exports